import React from "react"
import { useTranslation } from "react-i18next"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faChartLine, faCreditCard, faFileInvoiceDollar } from "@fortawesome/free-solid-svg-icons"
import Animate, { AnimationTypes } from "../../../components/Animate/Animate"
import { PopupHelpButton } from "../../../components/Help/PopupHelpButton"
import { useUpgradePlan } from "../../../context/useUpgradePlanContext"
import { PlanContent } from "../MyCompany/PlanPopup"

export const PlansPage: React.FC = () => {
  const { t } = useTranslation("pages")

  const { planUsageStatus } = useUpgradePlan()

  return (
    <div className="flex h-[calc(100%-25px)] w-full flex-col overflow-y-auto ">
      <Animate type={AnimationTypes.fadeInTraslate} duration="1.2s">
        <PlanContent
          onClose={() => {}}
          planUsageStatus={planUsageStatus}
          showCloseButton={false}
          containerClassName="w-full rounded-lg bg-white p-1 shadow-sm"
          forceRefreshPlanUsage
        />
      </Animate>
    </div>
  )
}
